import { render, staticRenderFns } from "./MyOrderDetails.vue?vue&type=template&id=a476b3d0&scoped=true&"
import script from "./MyOrderDetails.vue?vue&type=script&lang=js&"
export * from "./MyOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderDetails.vue?vue&type=style&index=0&id=a476b3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a476b3d0",
  null
  
)

export default component.exports